import React, { useContext, useState } from "react";
import { get } from "lodash";
import {
  FACEBOOK_PLATFORM,
  FAILED_TO_FETCH,
  INSTAGRAM_PLATFORM,
  WIKIPEDIA_PLATFORM,
  YOUTUBE_PLATFORM,
  API_URL,
} from "./constants";
import request from "../../utils/request";
import { ErrorContext } from "../../component/ErrorPopup/ErrorPopup";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

export const GetErrorMessage = (props) => {
  const values = useContext(ErrorContext);
  const [err, setErr] = useState(props.err);
  const errMessage = "Internal Server Error";
  const [called, setCalled] = useState(false);

  React.useEffect(() => {
    async function checkJson() {
      const error =
        get(props.err, "response", "") && !called && !values.isOpen
          ? await props.err.response.json()
          : props.err;
      setErr(error);
    }
    checkJson();
  }, [called, props.err, values.isOpen]);

  if (get(err, "message") === errMessage && !called) {
    try {
      toast.dismiss();
      setCalled(true);
      values.setIsOpen();
    } catch (e) {
      console.log(e);
    }
    return <></>;
  }
  if (err.message && get(err, "message") !== errMessage) {
    toast.update(get(props.toastProps, "toastProps.toastId", ""), {
      className: "",
    });
  }
  if (get(err, "message") === "Failed to fetch") {
    return <>{FAILED_TO_FETCH}</>;
  }

  return <>{get(err, "message")}</>;
};

GetErrorMessage.contextTypes = {
  setIsOpen: PropTypes.func,
  isOpen: PropTypes.bool,
};

export const getErrorMessage = GetErrorMessage;

export const getSocialMediaPayload = (
  instagramUrl,
  facebookUrl,
  youtubeUrl,
  wikipediaUrl,
) => {
  const socialMedia = [];
  if (instagramUrl) {
    socialMedia.push({
      platform: INSTAGRAM_PLATFORM,
      url: instagramUrl,
    });
  }
  if (facebookUrl) {
    socialMedia.push({
      platform: FACEBOOK_PLATFORM,
      url: facebookUrl,
    });
  }
  if (youtubeUrl) {
    socialMedia.push({
      platform: YOUTUBE_PLATFORM,
      url: youtubeUrl,
    });
  }
  if (wikipediaUrl) {
    socialMedia.push({
      platform: WIKIPEDIA_PLATFORM,
      url: wikipediaUrl,
    });
  }
  return socialMedia;
};

export const forbiddenCheck = () => {
  const data = {
    method: "GET",
  };
  const requestURL = `${API_URL}`;
  request(requestURL, data).catch();
};

export const hubSpotTracking = () => {
  const _hsq = window._hsq || [];
  _hsq.push([
    "setPath",
    `${window.location.pathname}${window.location.search}${window.location.hash}`,
  ]);
  _hsq.push(["trackPageView"]);
};

export const isChordCashLite = () =>
  window.location.hostname.includes("funding");

export const YT_VIDEO_ID_REGEX =
  /(?:youtube(?:-nocookie)?\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)|shorts?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;

export const YT_THUMBNAIL_URL =
  "https://img.youtube.com/vi/[VIDEO_ID]/sddefault.jpg";

export const YT_THUMBNAIL_SMALL =
  "https://img.youtube.com/vi/[VIDEO_ID]/mqdefault.jpg";
export const YT_EMBED_URL =
  "https://www.youtube-nocookie.com/embed/[VIDEO_ID]?rel=0&autoplay=1&modestbranding=1";

export const REMOVE_PARENTHESIS_REGEX = /\s*\(.*?\)\s*/g;
